/** Reserved error block — fixed height; visibility toggled without layout animation. */
export function FormErrorSlot({ message, testId = "form-error" }) {
    const visible = Boolean(message);
    return (
        <div className="auth-error-slot" aria-live="polite">
            <p
                className={`auth-error-slot__text ${visible ? "is-visible" : ""}`}
                data-testid={testId}
            >
                {message || "\u00A0"}
            </p>
        </div>
    );
}
